import { render, staticRenderFns } from "./InputParameterConfig.vue?vue&type=template&id=6436791d"
import script from "./InputParameterConfig.vue?vue&type=script&lang=js"
export * from "./InputParameterConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports